import { createContext, useContext, useState } from "react";

const SelectedCustomerContext = createContext();

export const SelectedCustomerProvider = ({ children }) => {
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  return (
    <SelectedCustomerContext.Provider
      value={{ selectedCustomerId, setSelectedCustomerId }}
    >
      {children}
    </SelectedCustomerContext.Provider>
  );
};

export const useSelectedCustomer = () => useContext(SelectedCustomerContext);
